<template>
  <div>
    <PageTitle icon="fa fa-home" main="Usuários" />
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="8">
              <b-input-group class="mt-1 mb-2">
                <b-form-input size="sm" v-model="search" type="text"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" @click="getData" variant="info">
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-button
                size="sm"
                @click="newRecord()"
                class="mt-1"
                style="float:right"
                variant="success"
              >
                <i class="fas fa-plus"></i> Novo
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-table
                id="tbl"
                hover
                bordered
                resposive
                small
                striped
                head-variant="dark"
                selectable
                select-mode="single"
                selected-variant="primary"
                show-empty
                empty-text="Sem dados para exibir"
                :per-page="pagination.perPage"
                :current-page="pagination.currentPage"
                :filter="search"
                :items="users"
                :fields="fields"
                :busy="isBusy"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Carregando...</strong>
                  </div>
                </template>
                <template v-slot:cell(actions)="data">
                  <b-button v-if="data.item.name != 'admin'" size="sm" variant="success" @click="editRecord(data.item)">
                    <i class="fas fa-edit"></i>
                  </b-button>
                  <b-button v-if="data.item.name != 'admin'" size="sm" variant="danger" @click="deleteRecord(data.item)">
                    <i class="fas fa-trash"></i>
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="viewRecord(data.item)">
                    <i class="fas fa-search"></i>
                  </b-button>
                  <b-dropdown right  variant="primary" no-caret size="sm" id="dropdown-1" class>
                    <template v-slot:button-content>
                      <i class="fas fa-bars"></i>
                    </template>
                  <b-dropdown-item @click="showChangePwd(data.item)">Alterar Senha</b-dropdown-item>
                    <b-dropdown-item v-if="data.item.perfil_id > 1" @click="showPermissions(data.item)">Permissões</b-dropdown-item>
                  </b-dropdown>

                  <!--
                  <b-button size="sm" variant="primary" title="Alterar Senha" @click="changePassword(data.item)">
                    <i class="fas fa-key"></i>
                  </b-button>
                  <b-button size="sm" variant="secondary" title="Permissões" @click="viewPermissions(data.item)">
                    <i class="fas fa-lock"></i>
                  </b-button>-->
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group label="Exibir" label-cols-lg="4" label-for="pageSize" label-size="sm">
                <b-form-select size="sm" id="pageSize" v-model="pagination.perPage">
                  <b-form-select-option :value="8">8</b-form-select-option>
                  <b-form-select-option :value="20">20</b-form-select-option>
                  <b-form-select-option :value="50">50</b-form-select-option>
                  <b-form-select-option :value="0">Tudo</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-pagination
                class="float-right"
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="tbl"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- MODAL -->
    <ModalUser :user="curRecord" :action="curAction" @updated="onUpdated" />
    <ChangePwdUser ref="modal-user-pwd" :user="curRecord" />
    <ModalPermissions :user="curRecord" />
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import ModalUser from "./ModalUser";
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import { mapState } from "vuex";
import ChangePwdUser from "./ChangePwdUser"
import ModalPermissions from './ModalPermissions'

export default {
  name: "Users",
  components: { PageTitle, ModalUser, ChangePwdUser, ModalPermissions },
  computed: mapState["user"],
  data: function() {
    return {
      pagination: {
        perPage: 8,
        totalRows: 0,
        currentPage: 1
      },
      search: "",
      isBusy: false,
      curAction: "view",
      users: [],
      curRecord: {},
      fields: [
        { key: "email", label: "Usuário", sortable: true },
        { key: "name", label: "Nome", sortable: true },
        {
          key: "perfil_id",
          label: "Perfil",
          sortable: true,
          formatter: function(val) {
            let _desc = [
              "",
              "Administrador",
              "Diretor de UO",
              "Gerente de Departamento",
              "Gestor de Contrato",
              "Colaborador",
              "Cliente"
            ];
            return _desc[val];
          }
        },
        /*{ key: "cliente.razao_social", label: "Empresa", sortable: true },*/
        { key: "actions", label: "Ações", class: "w160-field" }
      ]
    };
  },
  methods: {
      // eslint-disable-next-line
    showChangePwd(item){
        this.curRecord = {...item};
        let that = this
        setTimeout(() => {
          that.$bvModal.show('modal-user-pwd');
        }, 500);
    },
    // eslint-disable-next-line
    showPermissions(item){
      this.curRecord = {...item};
      let that = this
      setTimeout(() => {
        that.$bvModal.show('modal-permissions');  
      }, 500);
    },
    onUpdated() {
      this.curAction = "view";
      this.curRecord = {};
      this.getData();
    },
    editRecord(item) {
      this.curAction = "edit";
      this.curRecord = { ...item };
      this.$bvModal.show("modal-user");
    },
    viewRecord(item) {
      this.curAction = "view";
      this.curRecord = { ...item };
      this.$bvModal.show("modal-user");
    },
    newRecord() {
      this.curAction = "new";
      this.curRecord = {
        email: "",
        ind_ativo: 1,
        cliente_id: 1,
        perfil_id: 5
      };
      this.$bvModal.show("modal-user");
    },
    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir o Usuáro ${item.email}?`, {
          noFade: true
        })
        .then(yesno => {
          
          if (yesno) {
            this.isBusy = true;
            axios
              .delete(`${baseApiUrl}/usuarios/${item.email}`)
              .then(this.getData())
              .catch(err => {
                this.isBusy = false;
                showError(err);
              });
          }
        })
        .catch(err => {
          showError(err);
          console.log(err);
        });
    },
    getData() {
      this.isBusy = true;
      axios
        .get(`${baseApiUrl}/usuarios`)
        .then(resp => {
          this.isBusy = false;
          this.users = resp.data;
          this.pagination.totalRows = this.users.length;
        })
        .catch(err => {
          this.isBusy = false;
          showError(err);
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style>
</style>